const classes = {
  menu: 'profile-quick-menu',
  menuActive: 'profile-quick-menu_active',
  btn: 'profile-quick-menu-btn',
  dropdown: 'profile-quick-menu-dropdown',
  chevronDown: 'profile-quick-menu-un-chevron-down',
  chevronDownActive: 'profile-quick-menu-un-chevron-down_active',
};

function toggleDropDown(target) {
  const dropdown = target.querySelector(`.${classes.dropdown}`);

  target.classList.toggle(classes.menuActive);
}

document.addEventListener('DOMContentLoaded', () => {

  const assetId = '~/Parts/Views/Custom/Site/MyPageMenu.min.js';

  if (!window.umwAssets?.[assetId]) {
      console.error(`No context found for ${assetId}`);
      return;
  }

  for (const ctx of window.umwAssets[assetId]) {
    let targetProfileQuickMenu = null;

    document.getElementById(ctx.controlId).addEventListener('click', (e) => {
      if (e.target.classList.contains(classes.btn)) {
        e.preventDefault();

        targetProfileQuickMenu = e.target.closest(`.${classes.menu}`);
        toggleDropDown(targetProfileQuickMenu);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (targetProfileQuickMenu?.classList.contains(classes.menuActive)) {
          toggleDropDown(targetProfileQuickMenu);
        }
      }
    });
  }
});